import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { PublicHeader, PublicFooter } from "@/components/PublicShell";
import { CheckCircle, Heart, CaretLeft } from "@phosphor-icons/react";

/**
 * Standalone redirect target for payments taken outside our own checkout
 * flow (e.g. a Razorpay Payment Page shared directly with a donor) — there's
 * no donation record here to look up, just a generic thank-you. Not linked
 * from any nav/menu; only reachable via a direct link.
 */
export default function ThankYouPage() {
  const [params] = useSearchParams();
  const paymentId = params.get("razorpay_payment_id");

  return (
    <>
      <PublicHeader />
      <section className="max-w-2xl mx-auto px-5 md:px-10 py-16 text-center">
        <div className="fade-up">
          <div className="w-20 h-20 rounded-full bg-[#E6F3DC] text-[#2F7A4A] grid place-items-center mx-auto mb-6">
            <CheckCircle size={48} weight="fill" />
          </div>
          <h1 className="font-display font-bold text-3xl md:text-5xl mb-3" data-testid="thankyou-heading">Thank you for your donation!</h1>
          <p className="text-[#56624F] text-lg mb-8">
            Your generosity helps us rescue, treat and shelter animals in need. We&rsquo;re truly grateful for your support.
          </p>

          {paymentId && (
            <div className="seva-card text-left max-w-md mx-auto">
              <div className="flex justify-between"><span className="text-[#56624F]">Payment ID</span><span className="font-mono text-xs">{paymentId}</span></div>
            </div>
          )}

          <p className="text-sm text-[#56624F] mt-6">
            A payment confirmation has been sent to the email or phone number you provided during checkout.
          </p>

          <div className="mt-8">
            <Link to="/" className="btn-secondary inline-flex items-center gap-2" data-testid="thankyou-home">
              <CaretLeft size={16} /> Back to Home
            </Link>
          </div>
        </div>
        <div className="mt-10 flex items-center justify-center gap-2 text-[#56624F] text-sm">
          <Heart size={18} weight="fill" className="text-[#4FAC39]" /> Every rupee heals
        </div>
      </section>
      <PublicFooter />
    </>
  );
}
